import React, { useState } from "react";
import { Grid } from "@material-ui/core";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import MainNavbar from "utils/Navbars/MainNavbar.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle.js";
import { Device, DeviceContext } from 'utils/Device';

import NewQuotes from "components/MI/NewQuotes";
import NewApps from "components/all/NewApps";
import NewPolicies from "components/all/NewPolicies";
import PremiumsQuoted from "components/PremiumsQuoted";
import PremiumsBound from "components/PremiumsBound";
import CompCollQuotes from "components/CompCollQuotes";
import CompCollPolicies from "components/CompCollPolicies";
import CompCollVehiclesTypeQuotes from "components/CompCollVehiclesTypeQuotes";
import CompCollVehiclesTypePolicies from "components/CompCollVehiclesTypePolicies";
import EnvironmentServiceBanner from "components/EnvironmentServiceBanner";
import { Savings } from "components/Savings";
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { GWPPP_TransCode } from "components/all/GWPPP_TransCode";
import { CallAPI } from "services/API";
import PreviouslyInsured from "components/PreviouslyInsured";
import CreditScore from "components/CreditScore";
import Renewals from "components/Renewals";
import BookOfBusinessPercentage from "components/cities/BookOfBusinessPercentage";
import { LandingMessage } from "components/all/LandingMessage";

const useStyles = makeStyles(styles);

export default function Pages(props) {
    const [cookies, setCookie] = useCookies(['auth']);

    //Helper functions
    const changeStartDate = (date) => {
        setStartDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeEndDate = (date) => {
        setEndDate((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    };

    const changeCall = () => {
        RefreshComments();
    };

    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    //When user refresh page or submit new dates, get new data
    const RefreshComments = async () => {
        const data = await CallAPI("POST", "/GetComments", {
            startDate: startDate,
            endDate: endDate,
            states: states,
            city: city,
            page: 'Landing'
        });

        if (data) {
            setComments(data);
            setCall("true");
        }
    };

    //State Variables 
    var date = new Date();
    const [startDate, setStartDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [endDate, setEndDate] = React.useState((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
    const [states] = React.useState(["MI"]);
    const [city] = React.useState("Detroit");

    const [newQuotesSuccess, setNewQuotesSuccess] = useState(false);
    const [newAppsSuccess, setNewAppsSuccess] = useState(false);
    const [newPoliciesSuccess, setNewPoliciesSuccess] = useState(false);
    const [comments, setComments] = React.useState([]);
    const [call, setCall] = React.useState("false");
    const [lastUpdated, setLastUpdated] = React.useState(null);

    const device = Device();
    const isMobile = device.isMobile;
    const { ...rest } = props;
    const wrapper = React.createRef();
    const classes = useStyles();
    //When user refresh page or submit new dates, get all the data
    const didMount = React.useRef(false);
    React.useEffect(() => {
        async function func1() {
            //disable scrolling when page is loading
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.body.style.overflow = "hidden";
            document.body.style.height = "100%";
            if (call == "true" || call == null) {
                setNewQuotesSuccess(false);
                setNewAppsSuccess(false);
                setNewPoliciesSuccess(false);
            }
        }
        if (didMount.current && call === "true") {
            func1();
        } else {
            didMount.current = true;
        }

    }, [call]);
    React.useEffect(() => {
        async function func2() {
            setCall("false");
            //Enable scrolling when page is finished loading
            document.body.style.overflow = "auto";
            document.body.style.height = "auto";

        }
        if (newQuotesSuccess && newAppsSuccess && newPoliciesSuccess) {
            func2()
        }
    }, [newQuotesSuccess, newAppsSuccess, newPoliciesSuccess])

    const getActiveRoute = routes => {
        let activeRoute = "Default Brand Text";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
                ) {
                    return routes[i].name;
                }
            }
        }
        return activeRoute;
    }
    const history = useHistory();
    if (cookies.pass == undefined) {
        history.push('/');
    }
    return (
        <DeviceContext.Provider value={device}>
            <div>
                <div className={classes.wrapper} ref={wrapper}>
                    <MainNavbar state={states[0]} city={city} onChangeCall={changeCall} onChangeStartDate={changeStartDate} onChangeEndDate={changeEndDate} startDate={startDate} endDate={endDate} call={call} Text={"Detroit Dashboard"} lastUpdated={lastUpdated} {...rest} switchTo="pass" />
                    <div style={isMobile ? {} : { paddingRight: "17px" }}>
                        <LandingMessage />

                        <NewQuotes
                            call={call}
                            onSuccess={() => setNewQuotesSuccess(true)}
                            startDate={startDate}
                            endDate={endDate}
                            states={states}
                            city={city}
                            getQuoteType={true}
                        />
                        <NewApps
                            call={call}
                            onSuccess={() => setNewAppsSuccess(true)}
                            startDate={startDate}
                            endDate={endDate}
                            states={states}
                            city={city}
                        />
                        <NewPolicies
                            call={call}
                            onSuccess={() => setNewPoliciesSuccess(true)}
                            startDate={startDate}
                            endDate={endDate}
                            states={states}
                            city={city}
                        />

                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <PremiumsQuoted
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    getQuoteType={true}
                                    comments={comments.filter(x => x.table == 'Premiums Quoted')}
                                />
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <PremiumsBound
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Premiums Bound')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <CreditScore
                                    type={"Quotes"}
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    getQuoteType={true}
                                    comments={comments.filter(x => x.table == 'Quotes - Credit Score')}
                                />
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <CreditScore
                                    type={"Policies"}
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Policies - Credit Score')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <PreviouslyInsured
                                    type={"Quotes"}
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    getQuoteType={true}
                                    comments={comments.filter(x => x.table == 'Quotes - Previously Insured')}
                                />
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <PreviouslyInsured
                                    type={"Policies"}
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Policies - Previously Insured')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <CompCollQuotes
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Quotes By Coverage Type')}
                                />
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <CompCollPolicies
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Policies By Coverage Type')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item lg={6} xs={12}>
                                <CompCollVehiclesTypeQuotes
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Vehicles By Coverage Type - Quotes')}
                                />
                            </Grid>
                            <Grid item lg={6} xs={12}>
                                <CompCollVehiclesTypePolicies
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Vehicles By Coverage Type - Policies')}
                                />
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item lg={3} xs={0} />
                            <Grid item lg={6} xs={12}>
                                <Renewals
                                    call={call}
                                    startDate={startDate}
                                    endDate={endDate}
                                    states={states}
                                    city={city}
                                    comments={comments.filter(x => x.table == 'Renewals')}
                                />
                            </Grid>
                        </Grid>

                        <BookOfBusinessPercentage
                            title={"% OF MICHIGAN QUOTES AND POLICIES IN DETROIT"}
                            call={call}
                            startDate={startDate}
                            endDate={endDate}
                            states={states}
                            city={city}
                        />

                        <GWPPP_TransCode
                            startDate={startDate}
                            endDate={endDate}
                            call={call}
                            states={states}
                            city={city}
                            comments={comments.filter(x => x.table == 'Gross Written Premium' || x.table == 'Posted Premium')}
                        />
                        <Savings
                            call={call}
                            startDate={startDate}
                            endDate={endDate}
                            states={states}
                            city={city}
                        />
                        <EnvironmentServiceBanner call={call} setLastUpdated={setLastUpdated} />
                    </div>
                </div>
            </div>
        </DeviceContext.Provider>
    );
}